export const PREV_BUTTON_ID = 'prev';
export const NEXT_BUTTON_ID = 'next';
